import React from "react";

import { useTranslation } from "react-i18next";
import MarkdownRenderer from "react-markdown-renderer";

import SwitchOnOff from "../../../../components/common/tools/SwitchOnOff";
import InfoTooltip from "../../../../components/utils/InfoTooltip";
import { COMPONENT_TYPES } from "../../../../constants/componentType";
import WidgetConfig from "../section/WidgetConfig";

import type { JSX } from "react";

import type { WidgetComponent as WidgetComponentType } from "../../../../api/ProjectAPI.types";
import type { ComponentType } from "../../../../constants/componentType";

interface ContentWidgetComponentProps {
  component: WidgetComponentType;
  onChangeOption: (args: {
    type: ComponentType;
    value: string | number | boolean;
    key: keyof WidgetComponentType["params"];
  }) => void;
  onChangeEnabled: (args: { value: boolean; type: ComponentType }) => void;
}

function ContentWidgetComponent({
  component,
  onChangeOption,
  onChangeEnabled,
}: ContentWidgetComponentProps): JSX.Element {
  const { WIDGET } = COMPONENT_TYPES;

  const { t } = useTranslation("editor-widget");

  return (
    <div className="editor-form-section">
      <div className="editor-form-section-title">{t("widget")}</div>
      <div className="editor-form-row">
        <div className="editor-form-row editor-form-row-inline">
          <div className="editor-form-input">
            <SwitchOnOff
              checked={component?.enabled}
              name="activate_widget"
              size="sm"
              onChange={(value: boolean): void =>
                onChangeEnabled({ type: WIDGET, value })
              }
            />
          </div>
          <div className="editor-form-label">{t("activateWidget")}</div>
          <InfoTooltip>
            <MarkdownRenderer markdown={t("editor-help:widgetTooltip")} />
          </InfoTooltip>
        </div>
      </div>
      {component.enabled ? (
        <WidgetConfig
          component={component}
          description={t(`widget_desc_${component.section}`)}
          onChange={(
            value: string | number | boolean,
            key: keyof WidgetComponentType["params"],
          ): void => onChangeOption({ type: WIDGET, key, value })}
        />
      ) : null}
    </div>
  );
}

export default ContentWidgetComponent;
